<template>
  <div>

    <c-title>Förderprogramm bewerten</c-title>

    <c-busy v-if="loadStatus === $config.status.LOADING" />

    <div v-else>

      <c-form
        required-fields
        @submit.prevent="submit"
      >

        <c-form-rating
          id="rating"
          :errors="[{
            message: 'Dieses Feld ist erforderlich.',
            show: !$v.rating.rating.between
          }]"
          :has-error="$v.rating.rating.$error"
          :is-valid="!$v.rating.rating.$invalid"
          :max="5"
          v-model="rating.rating"
          aria-required="true"
          label="Bewertung *"
          @input="$v.rating.rating.$touch"
        />

        <c-form-textarea
          id="comment"
          :errors="[{
            message: `Bitte nicht mehr als ${$v.rating.comment.$params.maxLength.max} Zeichen.`,
            show: !$v.rating.comment.maxLength
          }]"
          :has-error="$v.rating.comment.$error"
          :is-valid="!$v.rating.comment.$invalid"
          v-model="rating.comment"
          label="Kommentar (max. 1000 Zeichen)"
          rows="6"
          @input="$v.rating.comment.$touch"
        />

        <c-button :busy="saveStatus === $config.status.SAVING">
          Abschicken
        </c-button>

      </c-form>

    </div>

  </div>
</template>

<script>
import CBusy from '@/components/CBusy'
import CButton from '@/components/CButton'
import CForm from '@/components/form/CForm'
import CFormInput from '@/components/form/CFormInput'
import CFormRating from '@/components/form/CFormRating'
import CFormTextarea from '@/components/form/CFormTextarea'
import CTitle from '@/components/CTitle'

import handleRequestError from '@/functions/handleRequestError'
import { between, maxLength, numeric, required } from 'vuelidate/lib/validators'

export default {
  name: 'VProcessRating',

  components: {
    CBusy,
    CButton,
    CForm,
    CFormInput,
    CFormRating,
    CFormTextarea,
    CTitle
  },

  props: {
    identifier: {
      type: String,
      required: true
    },
    period: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      loadStatus: this.$config.status.IDLE,
      saveStatus: this.$config.status.IDLE,
      rating: {
        comment: '',
        rating: 0
      },
      process: null
    }
  },

  validations: {
    rating: {
      comment: {
        maxLength: maxLength(1000)
      },
      rating: {
        between: between(1, 5),
        numeric,
        required
      }
    }
  },

  created () {
    this.loadStatus = this.$config.status.LOADING

    this.$api.get('workflow/process/' + this.identifier + '/')
      .then(response => {
        this.process = response.data
        this.loadStatus = this.$config.status.SUCCESS
        if (this.process.workflow.enable_rating === false) {
          this.$store.commit('notifications/add', {
            text: 'Für das gewählte Förderprogramm sind keine Bewertungen zulässig.',
            type: 'error'
          })
          this.$router.push({ name: 'dashboard' })
        }
      })
      .catch(() => {
        this.$store.commit('notifications/add', {
          text: 'Ungültiges Förderprogramm',
          type: 'error'
        })
        this.loadStatus = this.$config.status.ERROR
      })
  },

  methods: {
    submit () {
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.$store.commit('notifications/add', {
          text: 'Bitte geben Sie eine Bewertung ab',
          type: 'error'
        })

        return
      }

      this.status = this.$config.status.SAVING

      this.$api.post('workflow/rating/' + this.identifier + '/add/', {
        value: this.rating.rating,
        comment: this.rating.comment,
        period: this.period
      })
        .then(response => {
          this.$store.commit('notifications/add', {
            text: 'Vielen Dank für die Bewertung.',
            type: 'success'
          })
          this.$router.push({
            name: 'process-rating-list',
            params: { identifier: this.identifier }
          })
        })
        .catch(error => {
          handleRequestError({
            error,
            fallback: 'Leider ist etwas schief gelaufen. Bitte versuchen Sie es später erneut.'
          })

          this.status = this.$config.status.ERROR
        })
    }
  }
}
</script>
